import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  
  public isPageLoading = new BehaviorSubject(false);
  
  constructor() { }
}
